{
  "AUTOMATION": {
    "HEADER": "Automatisering",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Tilføj Automatiseringsregel",
    "LOADING": "Henter automatiseringsregler",
    "ADD": {
      "TITLE": "Tilføj Automatiseringsregel",
      "SUBMIT": "Opret",
      "CANCEL_BUTTON_TEXT": "Annuller",
      "FORM": {
        "NAME": {
          "LABEL": "Regel Navn",
          "PLACEHOLDER": "Indtast regelnavn",
          "ERROR": "Navn er påkrævet"
        },
        "DESC": {
          "LABEL": "Beskrivelse",
          "PLACEHOLDER": "Indtast regel beskrivelse",
          "ERROR": "Beskrivelse er påkrævet"
        },
        "EVENT": {
          "LABEL": "Begivenhed",
          "PLACEHOLDER": "Vælg venligst en",
          "ERROR": "Begivenhed er påkrævet"
        },
        "PHASE": {
          "LABEL": "Fase"
        },
        "ORDER": {
          "LABEL": "Rækkefølge",
          "ERROR": "Rækkefølge er påkrævet"
        },
        "CONDITIONS": {
          "LABEL": "Betingelser"
        },
        "ACTIONS": {
          "LABEL": "Handlinger"
        }
      },
      "CONDITION_BUTTON_LABEL": "Tilføj Betingelse",
      "ACTION_BUTTON_LABEL": "Tilføj Handling",
      "API": {
        "SUCCESS_MESSAGE": "Automatiseringsregel tilføjet med succes",
        "ERROR_MESSAGE": "Kunne ikke oprette en automatiseringsregel. Prøv igen senere"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Fase",
        "ORDER": "Rækkefølge",
        "NAME": "Navn",
        "DESCRIPTION": "Beskrivelse",
        "ACTIVE": "Aktiv",
        "CREATED_ON": "Oprettet den",
        "WAIT": "Ventetid"
      },
      "404": "Ingen automatiseringsregler fundet",
      "TABS": {
        "ALL": "Alle",
        "INSTANT": "Ved hændelse",
        "DELAYED": "Forsinkede"
      },
      "WAITS": "Venter {duration}"
    },
    "DELETE": {
      "TITLE": "Slet Automatiseringsregel",
      "SUBMIT": "Slet",
      "CANCEL_BUTTON_TEXT": "Annuller",
      "CONFIRM": {
        "TITLE": "Bekræft Sletning",
        "MESSAGE": "Er du sikker på du vil slette ",
        "YES": "Ja, Slet ",
        "NO": "Nej, Behold "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automatiseringsregel slettet",
        "ERROR_MESSAGE": "Kunne ikke slette en automatiseringsregel, prøv igen senere"
      }
    },
    "EDIT": {
      "TITLE": "Rediger Automatiseringsregel",
      "SUBMIT": "Opdater",
      "CANCEL_BUTTON_TEXT": "Annuller",
      "API": {
        "SUCCESS_MESSAGE": "Automatiseringsregel opdateret",
        "ERROR_MESSAGE": "Kunne ikke opdatere automatiseringsreglen. Prøv igen senere"
      }
    },
    "CLONE": {
      "TOOLTIP": "Klon",
      "API": {
        "SUCCESS_MESSAGE": "Automatisering klonet med succes",
        "ERROR_MESSAGE": "Kunne ikke klone automatiseringsreglen. Prøv igen senere"
      }
    },
    "FORM": {
      "EDIT": "Rediger",
      "CREATE": "Opret",
      "DELETE": "Slet",
      "CANCEL": "Annuller",
      "RESET_MESSAGE": "Ændring af begivenhedstype vil nulstille de betingelser og begivenheder, du har tilføjet nedenfor"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Du skal have mindst én betingelse for at gemme",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Du skal have mindst én handling for at gemme",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Indtast din besked her",
      "TEAM_DROPDOWN_PLACEHOLDER": "Vælg teams",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Vælg e-mail-indbakke og afsenderadresse",
      "SUBJECT_INPUT_PLACEHOLDER": "E-mailens emne",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Vælg den SMS-indbakke, der skal sendes fra",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Indtast SMS-teksten",
      "SMS_COUNTER": "{length}/{limit} tegn, {segments} SMS (før variablerne udfyldes)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Aktivér Automatiseringsregel",
      "DEACTIVATION_TITLE": "Deaktiver Automatiseringsregel",
      "ACTIVATION_DESCRIPTION": "Denne handling vil aktivere automatiseringsreglen '{automationName}'. Er du sikker på du vil fortsætte?",
      "DEACTIVATION_DESCRIPTION": "Denne handling vil deaktivere automatiseringsreglen '{automationName}'. Er du sikker på du vil fortsætte?",
      "ACTIVATION_SUCCESFUL": "Automatiseringsregel Aktiveret",
      "DEACTIVATION_SUCCESFUL": "Automatiseringsregel Deaktiveret",
      "ACTIVATION_ERROR": "Kunne ikke aktivere automatisering, prøv igen senere",
      "DEACTIVATION_ERROR": "Kunne ikke deaktivere automatisering, prøv igen senere",
      "CONFIRMATION_LABEL": "Ja",
      "CANCEL_LABEL": "Nej"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Kunne ikke uploade vedhæftning, Prøv venligst igen",
      "LABEL_IDLE": "Upload Vedhæftning",
      "LABEL_UPLOADING": "Uploader...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Upload Mislykkedes"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Værdi er påkrævet",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Denne handling virker kun, når regelfasen er sat til 'Før etikettering'.",
      "SKIP_AUTO_LABELING": "Denne handling virker kun, når regelfasen er sat til 'Før etikettering'.",
      "MOVE_CONVERSATION_TO_INBOX": "Kun e-mail- og webchatsamtaler kan flyttes til en e-mailindbakke, og en webchat kun hvis kontakten har en e-mailadresse. Ellers bliver samtalen, hvor den er, og der tilføjes i stedet en privat note.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Starter en ny samtale med kontakten i den valgte e-mail-indbakke, sender beskeden til kontakten via e-mail og markerer samtalen som løst. Det sker, hver gang reglen kører. Hvis kontakten ikke har en e-mailadresse, sendes der intet, og der tilføjes i stedet en privat note.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Starter en ny samtale med kontakten i den valgte SMS-indbakke, sender beskeden til kontakten som SMS og markerer samtalen som løst. Det sker, hver gang reglen kører. Beskeden er ren tekst uden vedhæftede filer. Hvis kontakten ikke har et telefonnummer, sendes der intet, og der tilføjes i stedet en privat note."
    },
    "NOTICES": {
      "AI_PROMPT": "Hver enkelt evaluering faktureres.",
      "INCOMING_MESSAGES_COUNT": "Dette henviser til antallet af indgående beskeder i samtalen.",
      "OUTGOING_MESSAGES_COUNT": "Dette henviser til antallet af udgående beskeder i samtalen."
    },
    "PHASE": {
      "BEFORE_LABELING": "Før etikettering",
      "AFTER_LABELING": "Efter etikettering"
    },
    "NONE_OPTION": "Ingen",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Indgående besked",
      "OUTGOING": "Udgående besked",
      "PRIVATE": "Privat note",
      "AI_SUMMARY": "AI-resumé"
    },
    "YES_NO_VALUES": {
      "YES": "Ja",
      "NO": "Nej"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Direkte besked på Instagram",
      "FACEBOOK_COMMENT": "Facebook-kommentar"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Samtale Oprettet",
      "CONVERSATION_UPDATED": "Samtale Opdateret",
      "MESSAGE_CREATED": "Besked oprettet",
      "CONVERSATION_OPENED": "Samtale Åbnet",
      "CONVERSATION_RESOLVED": "Samtale Løst",
      "PHONE_CALL_FINISHED": "Opkald Afsluttet"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Tildel til agent",
      "ASSIGN_TEAM": "Tildel et team",
      "ADD_LABEL": "Tilføj en etiket",
      "REMOVE_LABEL": "Fjern en etiket",
      "SEND_EMAIL_TO_TEAM": "Send en e-mail til team",
      "SEND_EMAIL_TRANSCRIPT": "Send en e-mailudskrift",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Send en detaljeret e-mailudskrift",
      "MUTE_CONVERSATION": "Sluk for samtale",
      "SNOOZE_CONVERSATION": "Udsæt samtale",
      "RESOLVE_CONVERSATION": "Løs samtale",
      "OPEN_CONVERSATION": "Åbn samtale",
      "SEND_WEBHOOK_EVENT": "Send webhook-begivenhed",
      "SEND_ATTACHMENT": "Send vedhæftning",
      "SEND_MESSAGE": "Send en besked",
      "ADD_NOTE": "Tilføj en note",
      "CHANGE_PRIORITY": "Skift prioritet",
      "ADD_SLA": "Tilføj SLA",
      "SKIP_AUTO_PRIORITY": "Spring automatisk prioritet over",
      "SKIP_AUTO_LABELING": "Spring automatisk etikettering over",
      "AUTO_TRANSLATE": "Oversæt besked",
      "AUTO_TRANSLATE_CONVERSATION": "Oversæt samtale",
      "MOVE_CONVERSATION_TO_INBOX": "Flyt samtale til indbakke",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Send besked i en ny samtale",
      "SEND_SMS_IN_NEW_CONVERSATION": "Send SMS i en ny samtale",
      "STOP_PROCESSING_RULES": "Stop behandling af regler"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "AI-filter",
      "MESSAGE_TYPE": "Beskedtype",
      "MESSAGE_CONTAINS": "Beskedindhold",
      "EMAIL": "E-mail",
      "INBOX": "Indbakke",
      "CHANNEL_TYPE": "Indbakketype",
      "CONVERSATION_LANGUAGE": "Samtalesprog",
      "PHONE_NUMBER": "Telefonnummer",
      "STATUS": "Status",
      "BROWSER_LANGUAGE": "Browsersprog",
      "MAIL_SUBJECT": "E-mailemne",
      "COUNTRY_NAME": "Land",
      "MARKETPLACE_COUNTRY": "Marketplace-land",
      "REFERER_LINK": "Refererer link",
      "ASSIGNEE_NAME": "Tildelt agent",
      "TEAM_NAME": "Team",
      "PRIORITY": "Prioritet",
      "CALL_DIRECTION": "Opkaldsretning",
      "MISSED_CALL": "Ubesvaret opkald",
      "MISSED_CALL_COUNT": "Antal ubesvarede opkald",
      "MESSAGE_SOURCE_TYPE": "Beskedkildetype",
      "INCOMING_MESSAGE_COUNT": "Antal indgående beskeder",
      "OUTGOING_MESSAGE_COUNT": "Antal udgående beskeder",
      "LABEL": "Etiket",
      "EMAIL_RECIPIENTS": "E-mailmodtager",
      "EMAIL_AUTO_REPLY": "E-mail er et automatisk svar",
      "ATTACHMENT_EXTENSION": "Filtype for vedhæftet fil",
      "EXTENSION": "Kaldt lokalnummer",
      "WORKING_HOURS": "Inden for åbningstiden",
      "AGENT_REPLIED": "Agent har svaret siden statusændringen"
    },
    "WAIT": {
      "RUN_LABEL": "Udfør handlingerne",
      "INSTANT": "Ved hændelse",
      "DELAYED": "Forsinket",
      "TRIGGER_LABEL": "Vent, indtil",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "En samtale forbliver i en status",
        "CUSTOMER_UNRESPONSIVE": "Kunden svarer ikke en agent",
        "AGENT_UNRESPONSIVE": "Kunden får ikke svar fra en agent"
      },
      "STATUS_LABEL": "Status",
      "STATUSES": {
        "OPEN": "Åben",
        "PENDING": "Afventer",
        "SNOOZED": "Udsat",
        "RESOLVED": "Løst"
      },
      "DELAY_LABEL": "Ventetid",
      "DELAY_ERROR": "Angiv en ventetid mellem 1 minut og 30 dage",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} t",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Handlingerne udføres, når en samtale har haft status {status} i {duration}. En statusændring inden da annullerer dem. Etiketter, åbningstider og agentsvar kontrolleres, når ventetiden er slut.",
        "CUSTOMER_UNRESPONSIVE": "Handlingerne udføres, når kunden ikke har svaret på en agents besked i {duration}. Et svar fra kunden annullerer dem; en ny besked fra agenten starter ventetiden forfra.",
        "AGENT_UNRESPONSIVE": "Handlingerne udføres, når kunden har ventet {duration} uden svar fra en agent. Et svar fra agenten annullerer dem."
      }
    }
  }
}
